class ProductSwiper extends HTMLElement {
    constructor() {
        super();
        this.mainSlider = null;
        this.thumbSlider = null;
        this.resizeObserver = null;
    }

    connectedCallback() {
        this.init();
        this.observeResize();
    }

    disconnectedCallback() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    init() {
        const mainEl = this.querySelector('.swiper-main');
        const thumbsEl = this.querySelector('.swiper-thumbs');

        if (!mainEl || !thumbsEl) return;

        this.thumbSlider = new Swiper(thumbsEl, {
            direction: 'vertical',
            spaceBetween: 12,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesProgress: true,
            observer: true,
            observeParents: true,
            breakpoints: {
                0: {
                    direction: 'horizontal',
                    slidesPerView: 6,
                    spaceBetween: 8,
                },
                1024: {
                    direction: 'vertical',
                    slidesPerView: 6,
                    spaceBetween: 12,
                },
            },
        });

        this.mainSlider = new Swiper(mainEl, {
            spaceBetween: 10,
            grabCursor: true,
            loop: false,
            autoHeight: false,
            pagination: {
                el: mainEl.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: mainEl.querySelector('.swiper-button-next'),
                prevEl: mainEl.querySelector('.swiper-button-prev'),
            },
            thumbs: {
                swiper: this.thumbSlider,
            },
        });
    }

    observeResize() {
        this.resizeObserver = new ResizeObserver(() => {
            this.thumbSlider?.update();
            this.mainSlider?.update();
        });

        this.resizeObserver.observe(document.body);
    }
}

if (customElements.get('product-template-swiper') === undefined) {
    customElements.define('product-template-swiper', ProductSwiper)
}